function isEmpty(obj: any): boolean{
  return typeof obj === "undefined" || obj === null || obj === "" || obj.toString().length === 0;
}

/**
 * 表单验证
 * @param rule 规则
 * @param value 输入框的值
 * @param callback
 */
export default function validator(rule: {required: boolean, requiredMsg?: string, reg?: RegExp, regMsg?: string, max?: number, maxMsg?: string, min?: number, minMsg?: string}, value: any[]| string | number | null, callback?: (msg: string) => void): boolean {
  if (rule.required && isEmpty(value)) {
    callback && callback(rule.requiredMsg || '');
    return false;
  }
  if (value !== null && !isEmpty(value) && rule.reg && !rule.reg.test(value.toString())) {
    callback && callback(rule.regMsg || '');
    return false;
  }
  if (value !== null && !isEmpty(value) && rule.max && value.toString().length > rule.max) {
    callback && callback(rule.maxMsg || '');
    return false;
  }
  if (value !== null && !isEmpty(value) && rule.min &&  value.toString().length < rule.min) {
    callback && callback(rule.minMsg || '');
    return false;
  }
  return true;
}
